import Vue from 'vue'
import Vuex from 'vuex'
// ✨【新增】导入持久化插件
import createPersistedState from 'vuex-persistedstate'

// 导入 user 模块
import user from './modules/user'
import upload from './modules/upload' // 引入新的upload模块
// ✨【新增】导入 site 模块 (请确保您已创建 store/modules/site.js 文件)
import * as site from './modules/site'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    count: 0
  },
  mutations: {
    increment(state) {
      state.count++
    }
  },
  actions: {
    increment({ commit }) {
      commit('increment')
    }
  },

  // 统一注册子模块
  modules: {
    user,
    upload,
    site // ✨【新增】注册 site 模块
  },

  // 仅在这里引入从 user.js 暴露出来的 plugin
  // 不直接在此处写配置，配置都在各模块内部
  plugins: [
    user.plugin, // 保留您原有的 user 插件
    
    // ✨【新增】为 site 模块添加持久化插件配置
    createPersistedState({
      // 存储的 key (自定义)
      key: 'my_site_vuex',
      // 默认使用 localStorage
      storage: window.localStorage,
      // 关键：指定仅持久化 site 模块
      paths: ['site'] 
    })
  ]
})